module.exports = "<app-balloon [direction]=\"direction\" class=\"hint\">\n  <i balloon-opener class=\"fa fa-question-circle\" aria-hidden=\"true\"></i>\n  <ng-content></ng-content>\n</app-balloon>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/hint/hint.component.html
// module id = YjXb
// module chunks = 6